import React from "react";
import { mandatoryColumns } from "../../constants/static";

export default function MandatoryColumnTDs(props, index) {
  const category = props.collection.filter((x) => x.fieldName === mandatoryColumns.ItemCategoryTitle)[0];
  const anyCategory =
    props.articles.filter(
      (x) =>
        x.dataCollection?.filter((y) => y.fieldName === mandatoryColumns.ItemCategoryTitle && y.fieldValue.length > 0)
          .length > 0
    ).length > 0;

  // no cat no any
  if (!category && !anyCategory) {
    return null;
  }

  // no cat but any
  if (!category && anyCategory) {
    return (
      <td className="c-parts-listing__table-item" key={index}>
        -
      </td>
    );
  }

  // cat
  return (
    <td className="c-parts-listing__table-item" key={category.fieldHeader}>
      <span className="c-parts-listing__label">{category.fieldHeader}</span>
      {category.fieldValue} {category.fieldUnit}
    </td>
  );
}
